import {AnyProduct, getMinimalProductPrice} from "@/entities/product";
import {FavoriteProduct} from "../model/types";

export function mapProductToFavorite(product: AnyProduct): FavoriteProduct {
    return {
        id: product.id,
        article: product.article,
        category: product.category,
        count: "count" in product ? product.count : 1,
        currentPrice: getMinimalProductPrice(product),
        h1: product.h1,
        img: product.img,
        price: product.price,
    };
};
